import { useAppSelector } from "../redux/store";
import { ConnectionStatus } from "../redux/slices/meta";

const getConnectionStatusText = (status: ConnectionStatus): string => {
  switch (status) {
    case ConnectionStatus.CONNECTED:
      return "player connected";
    case ConnectionStatus.CONNECTING:
      return "connecting to server";
    case ConnectionStatus.RECONNECTING:
      return "reconnecting to server";
    case ConnectionStatus.CONNECTION_ERROR:
      return "connection error";
    case ConnectionStatus.CONNECTION_LOST:
      return "connection lost, retrying...";
    case ConnectionStatus.CONNECTION_FAILED:
      return "could not reconnect to server";
    case ConnectionStatus.DISCONNECTED:
    default:
      return "player disconnected";
  }
};

const getStatusIndicatorClass = (status: ConnectionStatus): string => {
  switch (status) {
    case ConnectionStatus.CONNECTED:
      return "bg-green-400";
    case ConnectionStatus.CONNECTING:
    case ConnectionStatus.RECONNECTING:
    case ConnectionStatus.CONNECTION_LOST:
      return "bg-yellow-400 animate-pulse";
    case ConnectionStatus.CONNECTION_ERROR:
    case ConnectionStatus.CONNECTION_FAILED:
      return "bg-red-500";
    case ConnectionStatus.DISCONNECTED:
    default:
      return "bg-slate-400";
  }
};

export const useConnectionStatus = () => {
  const connectionStatus = useAppSelector(
    (state) => state.meta.connectionStatus
  );

  return {
    connectionStatus,
    statusText: getConnectionStatusText(connectionStatus),
    indicatorClass: getStatusIndicatorClass(connectionStatus),
  };
};
